export const KEK_EMOJI: readonly string[] = [
  '😸',
  '🤩',
  '😁',
  '🤣',
  '✨',
  '🌸',
  '❤️',
];

export const CRINGE_EMOJI: readonly string[] = [
  '💔',
  '💢',
  '🚽',
  '👎',
  '😡',
  '😭',
  '💩',
];

export const NEUTRAL_EMOJI: readonly string[] = [
  '🙂',
  '😐',
  '🤔',
  '🤷',
  '😶',
  '🙃',
];

export const CUSTOM_EMOJI: readonly string[] = [
  '✨',
  '🎉',
  '⚡️',
  '🔥',
  '💫',
  '✌️',
  '👀',
  '🌟',
];
